// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4696) return "static/chunks/4696-692b86a6be1157c6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bc042484a359a93c" + ".js";
};